/**
 * Here we declare the enums, used as routes for certain parts of applications
 */

/**
 * Apps
 */

export enum App {
    AccountManagement = 'accountmanagement',
    DamageTracking = 'damagetracking',
    Deployments = 'deployments',
    Finance = 'finance',
    ContactManagement = 'contactmanagement',
    OrderManagement = 'ordermanagement',
    TransportPlanner = 'transportPlanner',
    Containers = 'containers',
    Pricing = 'pricing',
    Forecast = 'forecast',
    RelationshipsManagement = 'relationshipsmanagement',
    Dashboard = 'dashboard',
    Gateways = 'gateways',
    Loggers = 'loggers',
    Rates = 'rate',
}

/**
 * Account Management
 */
export enum AccountManagementDomains {
    KamDashboard = 'kam-dashboard',
    Accounts = 'accounts',
    RegionalGroups = 'regional-groups',
    Opportunitites = 'opportunities',
    Lanes = 'lanes',
    AQuotes = 'a-quotes',
    CQuotes = 'c-quotes',
    SimplifiedCQuotes = 'simplified-c-quotes',
    PreBookings = 'pre-bookings',
}

export enum AccountTabs {
    Opportunities = 'opportuninites',
    Lanes = 'lanes',
    RegionalGroups = 'regional-groups',
    Contacts = 'contacts',
    AQuotes = 'a-quotes',
    CQuotes = 'c-quotes',
    BillingCompanies = 'billing-companies',
    Addresses = 'addresses',
    ActivityRecords = 'activity-records',
}

export enum AQuotesTab {
    AssignQuote = 'assign-quote',
    ReviewGroup = 'review-group',
    AssignPricing = 'assign-pricing',
    AwardReject = 'award-reject',
    QuotePdf = 'quote-pdf',
}

export enum CQuotesTab {
    AwardReject = 'award-reject',
    QuotePdf = 'quote-pdf',
}

export enum RegionalGroupsTabs {
    Opportunities = 'opportunities'
}

export enum OpportunitiesTabs {
    Lanes = 'lanes',
    ContainerInformation = 'container-information',
}

export enum AssingPricingSubRoutes {
    LaneFees = 'lane-fees',
}

/**
 * Contact Management
 */
export enum ContactManagementDomains {
    Companies = 'companies',
    Locations = 'locations',
    BillingCompanies = 'billing-companies',
    Contacts = 'contacts',
    Countries = 'countries',
    Users = 'users',
    AirportsAndSeaports = 'ports',
}

export enum ContactsTableTabs {
    Prospect = 'prospect'
}

export enum CompaniesTabs {
    SkyMind = 'skymind',
    Tracking = 'tracking',
}

export enum ContactsTabs {
    SAPContact = 'sap-contact',
}

export enum CountriesTableTabs {
    HsCode = 'hs-code'
}

export enum LocationsTabs {
    Areas = 'areas',
    SkyMind = 'skymind',
}

export enum AirportsAndSeaportsDomains {
    Airports = 'airports',
    Seaports = 'seaports',
}

export enum BillingCompaniesTabs {
    CustomerSalesArea = 'customer-sales-area',
    SalesAreaTax = 'sales-area-tax',
    Communication = 'communication',
    Abacus = 'abacus'
}

/**
 * Container Management
 */
export enum ContainerManagementDomains {
    Containers = 'containers',
    ContainerDashboard = 'container-dashboard',
    ContainerTypes = 'container-type',
    ServiceCenters = 'service-centers'
}

export enum ContainersTabs {
    ChangeStatus = 'changestatus',
    Loggers = 'loggers',
    SensorData = 'sensordata',
    Damages = 'damages',
    GeoLocation = 'geolocation',
    AutomatedSensorChecks = 'sensorchecks',
}

export enum ContainersTablesTab {
    Operational = 'operational'
}

/**
 * Damage Tracking
 */
export enum DamageTrackingDomains {
    Damages = 'Damages',
    DamageTypes = 'damage-types'
}

/**
 * Finance
 */
export enum FinanceDomains {
    Invoices = 'invoices',
    FxRates = 'fx-rates',
}

export enum InvoicesTableTabs {
    BaseLeaseCreated = 'base-lease-created',
    ExtraDaysToBeCreated = 'extra-days-to-be-created',
    ExtraDaysCreated = 'extra-days-created',
    CancelledBilling = 'cancelled-billing',
    BillingCompleted = 'billing-completed',
    RequiredManualBillingReview = 'requires-manual-billing-review',
    NotSyncedBillingCompany = 'not-synced-billing-company',
    BillingNotCompleted = 'billing-not-completed',
}

/**
 * Forecast
 */
export enum ForecastDomains {
    ShortTermForecasts = 'shortterm-forecasts',
}

export enum ShortTermForecastsTabs {
    CurrentMonthUpdate = 'current-month-update'
}

/**
 * Logger
 */
export enum LoggerTabs {
    Documents = 'documents'
}

/**
 * Gateways
 */
export enum GatewaysTabs {
    WorkSchedule = 'work-schedule',
}

/**
 * Order Management
 */
export enum OrderManagementDomains {
    DailyOps = 'daily-ops',
    Pooling = 'pooling',
    OpenBookings = 'open-bookings',
    Lanes = 'lanes',
    CustomerOrders = 'customer-orders',
    InternalOrders = 'internal-orders',
    FreightForwarders = 'freight-forwarders',
    PreBookings = 'pre-bookings',
    CreateAirlineLease = 'create-airline-lease',
    CreateDirectLease = 'create-direct-lease',
    LongTermLease = 'long-term-lease',
    ProformaInvoices = 'proforma-invoices',
}

export enum CustomerTransportTabs {
    Notifications = 'notifications',
    OrderChanges = 'order-changes',
    ContainerSelection = 'container-selection',
    OrderSteps = 'order-steps',
    BillingInformation = 'billing-information',
    Invoices = 'invoices',
    SharedPositioning = 'shared-positioning',
    OrderConfirmation = 'order-confirmation',
    ChangeRequestApproval = 'change-request-approval',
}

export enum InternalTransportTabs {
    Notifications = 'notifications',
    ContainerSelection = 'container-selection',
    OrderSteps = 'order-steps',
}

export enum InternalTransportDomainsRoutes {
    PickupAddInfo = 'pickup-add-info',
    PickupAddPickup = 'pickup-add-pickup',
    PickupDeliveryConfirmation = 'pickup-delivery-confirmation',
    TransportDeparture = 'transport-departure',
    TransportArrival = 'transport-arrival',
    DeliveryAddInfo = 'delivery-add-info',
    DeliveryAddPickup = 'delivery-add-pickup',
    DeliveryConfirmation = 'delivery-confirmation',
}

export enum LanesDomainRoutes {
    OperationalLanes = 'operational',
    UpcomingLanes = 'upcoming',
}

export enum LanesTabs {
    LaneImplementation = 'laneimplementation',
    Notifications = 'notifications'
}

export enum LongTermLeaseTabs {
    Containers = 'containers',
    RelatedOrders = 'related-orders',
    ContractChangeHistory = 'contract-change-history',
}

/**
 * Pricing
 */
export enum PricingDomains {
    PricingDashboard = 'pricing-dashboard',
    ContractBasis = 'contract-basis',
    LaneGroups = 'lane-groups',
    LaneFees = 'lane-fees',
    Lanes = 'lanes',
    AlLogisticPricing = 'al-logistic-pricing',
    AlLeasePricing = 'al-lease-pricing',
    AQuotes = 'a-quotes'
}

export enum ContractBasisTabs {
    ContractBasis = 'contract-basis',
    AdditionalFees = 'additional-fees',
    LongTermLeaseFees = 'long-term-lease-fees',
    LaneGroups = 'lane-groups',
    CreateQuote = 'create-quote'
}

export enum LaneGroupsTabs {
    Lanes = 'lanes',
    LaneFees = 'lane-fees',
}

export enum LaneGroupTableTabs {
    LaneInProgress = 'lane-in-progress',
    LanePriced = 'lane-priced',
    LaneAwarded = 'lane-awarded'
}

/**
 * Rates
 */
export enum RatesDomains {
    ARateCards = 'a-rate-cards',
    CRateCards = 'c-rate-cards',
}

export enum RateCardsTabs {
    BaseLease = 'base-lease',
    OtherLaneFees = 'other-lane-fees',
    AdditionalFees = 'additional-fees',
    EmbargoCountries = 'embargo-countries',
    Margins = 'margins',
    LogisticsCosts = 'logistics-costs',
    RegionalServiceAvailability = 'regional-service-availability',
    RateCard = 'rate-card',
}

/**
 * Relationships Management
 */
export enum RelationshipsManagementDomains {
    ActivityRecords = 'activity-records',
    Engagements = 'engagements',
}

export enum EngagementTableTabs {
    Contacts = 'contacts'
}

/**
 * Transport Planner
 */
export enum TransportPlannerDomains {
    Simulation = 'simulation',
    C02Calculation = 'co2Calculation',
    SavedSimulations = 'savedSimulations',
}

/**
 * Service Center
 */
export enum ServiceCenterTabs {
    Monitoring = 'monitoring',
    ScenarioEditor = 'scenario-editor',
    RelatedOrders = 'related-orders',
    WorkSchedule = 'work-schedule',
    PoolingDataUpdate = 'pooling-data-update',
    DailyOpsDataUpdate = 'daily-ops-data-update',
}
